import { NEXTBTN_IS_CHECKED, CONFIRMBTN_IS_CHECKED, UPDATE_PAGE_NUMBER } from '../actions/types.js';

const INITIAL_STATE = {
	nextBtn: false,
	page: 1,
	confirmBtn: false
};

const global = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case NEXTBTN_IS_CHECKED:
			var nextBtn = action.payload.nextBtn;
			return { ...state, nextBtn: nextBtn }
		case CONFIRMBTN_IS_CHECKED:
			var confirmBtn = action.payload.confirmBtn;
			return { ...state, confirmBtn: confirmBtn }
		case UPDATE_PAGE_NUMBER: 
			return {
				...state, 
				page: state.page + action.payload.page
			}
		default:
			return state;
	}
}

export default global;